import { DEFAULT_MIFID_STATUS, Endpoints, FLOW_TYPE } from 'consts';
import { HTTP } from 'services/http';

export async function MifidStatus(ssn: string, flowType: string, API: Endpoints, http: HTTP) {
	if (ssn && FLOW_TYPE.ES_MV === flowType) {
		return http.get(`${API.getMifidStatus}?ssn=${ssn}`);
	}
	return DEFAULT_MIFID_STATUS;
}
